import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Overlay from 'Shared/Overlay';
import { default as touchSequence, UNKNOWN } from './touch-sequence';
import { on } from 'SiteLayout/Root';
import onload from 'Shared/onload';
import { isIOS } from 'Shared/device-type';
import swiper from './swiper';
import * as styles from './base.scss';
export default class Flyout extends React.Component {
    constructor() {
        super(...arguments);
        this.onTouchStart = (e) => {
            this.touchSequence && this.touchSequence.push(e.touches[0]);
            this.swiper && this.swiper.onTouchStart(e);
        };
        this.onTouchMove = (e) => {
            if (!this.props.canOpen || !this.touchSequence || (isIOS() && !this.props.isOpen) || e.touches.length > 1) {
                return;
            }
            const touch = e.touches[0];
            this.touchSequence.push(touch);
            // Have we gotten enough touch events to be able to detect
            // how the user is swiping?
            const swipeDirection = this.touchSequence.swipeDirection();
            if (swipeDirection === UNKNOWN) {
                return;
            }
            this.swiper && this.swiper.onTouchMove(e);
        };
        this.onTouchEnd = (e) => {
            this.swiper && this.swiper.onTouchEnd(e);
            this.touchSequence && this.touchSequence.reset();
        };
    }
    componentDidMount() {
        if (this.props.isOpen && !!this.props.toggleFlyout) {
            this.enableSwiper();
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen && !this.props.isOpen && !!this.props.toggleFlyout) {
            this.enableSwiper();
        }
        this.swiper && this.swiper.isOpen(nextProps.isOpen);
        if (!nextProps.isOpen && this.props.isOpen) {
            this.disableSwiper();
        }
    }
    componentWillUnmount() {
        this.disableSwiper();
    }
    enableSwiper() {
        if (this.touchStartUnsubscribe) {
            // We're already enabled
            return;
        }
        // We use `Root/on` here to enable the throttled variant of `window.addEventListener('resize', ...`
        this.touchStartUnsubscribe = on('touchstart', this.onTouchStart);
        this.touchMoveUnsubscribe = on('touchmove', this.onTouchMove);
        this.touchEndUnsubscribe = on('touchend', this.onTouchEnd);
        // We have to wait until the element has been layed out in order to
        // know it's geometry
        onload(() => {
            // This can happen if the element was destroyed before we got a chance
            // to initialize the swipe
            if (!this.base) {
                return;
            }
            const overlayDom = ReactDOM.findDOMNode(this.overlay);
            this.touchSequence = touchSequence();
            this.swiper = swiper({
                touchSequence: this.touchSequence,
                container: this.base,
                overlay: overlayDom,
                isOpen: this.props.isOpen,
                position: this.props.position,
                toggleFlyout: this.props.toggleFlyout,
            });
        });
    }
    disableSwiper() {
        if (this.touchStartUnsubscribe) {
            this.touchStartUnsubscribe();
            this.touchStartUnsubscribe = null;
        }
        if (this.touchMoveUnsubscribe) {
            this.touchMoveUnsubscribe();
            this.touchMoveUnsubscribe = null;
        }
        if (this.touchEndUnsubscribe) {
            this.touchEndUnsubscribe();
            this.touchEndUnsubscribe = null;
        }
    }
    render() {
        const { isOpen, toggleFlyout } = this.props;
        let position = styles.left;
        if (this.props.position === 'right') {
            position = styles.right;
        }
        return (React.createElement(Overlay, { onClose: toggleFlyout, enabled: isOpen, elementRef: (el) => (this.overlay = el) },
            React.createElement("div", { className: classnames(styles.base, position, this.props.fillWidth && styles.fillWidth, {
                    [styles.open]: isOpen,
                }), onClick: e => e.stopPropagation(), ref: el => (this.base = el) }, this.props.children)));
    }
}
